// lib
import React from "react";
import PropTypes from "prop-types";
import { Draggable } from "react-beautiful-dnd";
// src
import EditableLine from "../EditableLine";

const DraggableCategory = ({
  // parent props
  category,
  dispatch,
  onRemove,
}) => {
  return (
    <Draggable key={category.id} draggableId={category.id} index={category.index}>
      {(provided) => (
        <div ref={provided.innerRef} {...provided.draggableProps}>
          <EditableLine
            preset={category}
            draggable={provided}
            dispatch={dispatch}
            onRemove={onRemove}
          />
        </div>
      )}
    </Draggable>
  );
};

DraggableCategory.propTypes = {
  // parent props
  category: PropTypes.object.isRequired,
  dispatch: PropTypes.func.isRequired,
  onRemove: PropTypes.func.isRequired,
};

export default DraggableCategory;
